
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppTemplateVariableMapGrid extends Serenity.EntityGrid<WhatsAppTemplateVariableMapRow, any> {
        protected getColumnsKey() { return WhatsAppTemplateVariableMapColumns.columnsKey; }
        protected getDialogType() { return WhatsAppTemplateVariableMapDialog; }
        protected getIdProperty() { return WhatsAppTemplateVariableMapRow.idProperty; }
        protected getInsertPermission() { return WhatsAppTemplateVariableMapRow.insertPermission; }
        protected getLocalTextPrefix() { return WhatsAppTemplateVariableMapRow.localTextPrefix; }
        protected getService() { return WhatsAppTemplateVariableMapService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}